import { parsePossiblyBrokenJson } from '../helpers/common';

function extractJsonObjects(buffer) {
  const objects = [];
  let depth = 0;
  let start = 0;

  for (let i = 0; i < buffer.length; i++) {
    if (buffer[i] === '{') {
      if (depth === 0) start = i;
      depth++;
    } else if (buffer[i] === '}') {
      depth--;
      if (depth === 0) {
        objects.push(buffer.slice(start, i + 1));
      }
    }
  }

  const last = objects.length ? buffer.slice(buffer.lastIndexOf('}') + 1) : buffer;
  return { objects, leftover: last };
}

function applyChunk(handlers, type, data, { botChatSeparator = '\n' } = {}) {
  const {
    updateChatLoaderMessage,
    updateBotChat,
    updateToolImages,
    updateChatSource,
  } = handlers;

  if (type === 'intermediate_step') {
    updateChatLoaderMessage?.(data);
    updateBotChat?.(botChatSeparator);
  }
  if (type === 'content') updateBotChat?.(data);
  if (type === 'tool_image_result') updateToolImages?.(data);
  if (type === 'tool_result') {
    const fixed = parsePossiblyBrokenJson(data);
    updateChatSource?.(fixed?.search_results);
  }
}

export async function processChatStream(reader, handlers, options = {}) {
  const decoder = new TextDecoder();
  let buffer = '';

  while (true) {
    const { done, value } = await reader.read();
    if (done) break;

    buffer += decoder.decode(value, { stream: true });
    const { objects, leftover } = extractJsonObjects(buffer);

    for (const jsonString of objects) {
      try {
        const parsed = JSON.parse(jsonString);
        applyChunk(handlers, parsed.type, parsed.data, options);
      } catch (err) {
        console.warn('Failed to parse chunk:', jsonString, err);
      }
    }

    buffer = leftover;
  }

  if (buffer.trim()) {
    try {
      const parsed = JSON.parse(buffer);
      applyChunk(handlers, parsed.type, parsed.data, options);
    } catch (err) {
      console.warn('Failed final parse:', buffer, err);
    }
  }

  handlers.updateChatLoaderMessage?.('');
}
